import { SelectMultiOptionWrapper } from "../Select/SelectMultiOptionWrapper.js";
import { PRIORITY_VALUE_NAME_MAP, PRIORITY_VALUE_VARIANT_MAP } from "./constants.js";
import { useMemo } from "react";
import { ColorCircle, Select } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/components/Priority/SelectPriority.tsx
var ListItem = (priority) => /* @__PURE__ */ jsxs("div", {
	className: "gap-x-sm inline-flex w-full items-baseline justify-between",
	children: [/* @__PURE__ */ jsx("span", { children: priority.label }), /* @__PURE__ */ jsx(ColorCircle, { variant: PRIORITY_VALUE_VARIANT_MAP[priority.value] })]
});
var SelectedMulti = (priority, onRemove) => /* @__PURE__ */ jsx(SelectMultiOptionWrapper, {
	onRemove,
	children: /* @__PURE__ */ jsxs("div", {
		className: "space-x-xs px-xs flex max-w-full items-baseline",
		children: [/* @__PURE__ */ jsx(ColorCircle, { variant: PRIORITY_VALUE_VARIANT_MAP[priority.value] }), /* @__PURE__ */ jsx("span", {
			className: "truncate",
			children: priority.label
		})]
	})
});
var SelectedSingle = (priority) => /* @__PURE__ */ jsxs("div", {
	className: "py-xs gap-x-sm inline-flex items-baseline",
	children: [/* @__PURE__ */ jsx(ColorCircle, { variant: PRIORITY_VALUE_VARIANT_MAP[priority.value] }), /* @__PURE__ */ jsx("span", { children: priority.label })]
});
var getOptions = () => {
	return Object.entries(PRIORITY_VALUE_NAME_MAP).map(([priority, priorityName]) => ({
		label: priorityName,
		value: priority
	})).sort((a, b) => {
		if (a.value < b.value) return 1;
		if (a.value > b.value) return -1;
		return 0;
	});
};
var SelectPriority = (props) => {
	const options = useMemo(() => getOptions(), []);
	return /* @__PURE__ */ jsx(Select, {
		...props,
		onChangeValue: (value) => {
			props?.onChangeValue?.(typeof value !== "undefined" ? +value : value);
		},
		value: typeof props.value !== "undefined" ? `${props.value}` : props.value,
		RenderListItem: ListItem,
		RenderSelectedMulti: SelectedMulti,
		RenderSelectedSingle: SelectedSingle,
		options
	});
};
//#endregion
export { SelectPriority };

//# sourceMappingURL=SelectPriority.js.map